import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { REGEX } from 'src/app/constants/regex';
import { HttpService, UtilityService } from 'src/app/services';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})

export class ForgotPasswordComponent implements OnInit {
  isLoading: boolean = false;
  forgotPassword: FormGroup;
  email = new FormControl ('', [Validators.required, Validators.pattern(REGEX.EMAIL)]);
  listItem: any = '';
  emailValue = '';
  constructor(private fb: FormBuilder, public http: HttpService,private snackbar: MatSnackBar, private util: UtilityService) {
    this.forgotPassword = this.fb.group ({
      email: this.email,
    })
   }
  ngOnInit(): void {
  }

  submit() {
    if(this.forgotPassword.valid) {
      this.isLoading = true;
      this.http.flightsave(`apiV2/auth/forgot-password`, this.forgotPassword.value).subscribe(
        res => {
          if(res.statusCode === 200) {
            this.listItem = res.data;
            this.isLoading = false;
          }
        }, err => {
          this.isLoading = false;
          this.listItem = err?.error;
          this.util.errorMessage(err)
          this.snackbar.open(err?.error?.message, 'Error', {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
          }
        );
      })
    }
  }
}
